import { render, staticRenderFns } from "./goodsRecord.vue?vue&type=template&id=1d463425&scoped=true"
import script from "./goodsRecord.vue?vue&type=script&lang=js"
export * from "./goodsRecord.vue?vue&type=script&lang=js"
import style0 from "./goodsRecord.vue?vue&type=style&index=0&id=1d463425&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d463425",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d463425')) {
      api.createRecord('1d463425', component.options)
    } else {
      api.reload('1d463425', component.options)
    }
    module.hot.accept("./goodsRecord.vue?vue&type=template&id=1d463425&scoped=true", function () {
      api.rerender('1d463425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/warehouseManagement/warehouseStock/goodsRecord.vue"
export default component.exports